<template>
  <div>
    <a :href="$host + href" style="color:#7a7157;text-decoration:none;white-space:nowrap">{{ name }}</a>
  </div>
</template>

<script>
export default {
  props: {
    href: String,
    name: String
  }
}
</script>

<style>

</style>